import MainPage from './layouts/MainPage';


function App() {
  return (
      <MainPage></MainPage>
  );
}

export default App

